export default __webpack_public_path__ + "static/media/Jobs.477d4908.svg";